import {DDR} from './ddr.class';

export class DDRMen70Strategy extends DDR {
  constructor() {
    super([900, 15, 15, 120, 90, 1.2, 1.3, 16, 1.7, 400, 2.4, 5, 30, 550, 1200, 30, 900, 4, 150, 8, 420, 2.3, 700, 55, 11]);
  }
}
